export const en = {
    city_to: 'City to',
    date_from__gte: 'Date from',
    date_from__lte: 'Date until',
    manager: 'Manager',
    person: 'Traveler',
    tracker_issue: 'Ticket',
    date_placeholder: 'Choose date',
};
